module.exports = __webpack_public_path__ + "static/media/lifestyle1-small.57464704.jpg";